export enum MemberSetTypeEnum {
  Unknown = "Unknown",

  Census = "Census",

  Full = "Full",
}

export enum MemberSetVersionStatus {
  Created = "created",

  Activated = "activated",

  Archived = "archived",

  FailedUpload = "failedUpload"
}
